import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import { DARK_THEME } from '@rsos/theme/constants';

const THEME_CONTROL_EVENT_NAMES = {
  THEME_CONTROL_CLICK: 'click_turn_night_mode',
};

export const trackThemeControlClicks = (mode, irpVersion) => {
  const themeStatus = mode === DARK_THEME ? 'on' : 'off';
  gspx.trackEvent({
    name: THEME_CONTROL_EVENT_NAMES.THEME_CONTROL_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.NAVBAR,
    additionalKeys: {
      legacy_category: 'Navigation',
      legacy_name: `Click turn ${themeStatus} night mode`,
      Category: 'Navigation',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
